import { motion } from "framer-motion";
import {
    FaBug,
    FaClipboardCheck,
    FaClock,
    FaHome,
    FaLeaf, FaShieldAlt, FaUserShield,
    FaWarehouse,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import fumigation from '../assets/fum5.webp';
import pest from '../assets/fum6.jpg';
import herobg from '../assets/fum7.jpg';
import bgImage from "../assets/pest2.jpg";


const categories = [
  {
    id: 1,
    title: "Certified & Experienced Team",
    description:
      "Our pest control technicians are trained and certified to handle residential, commercial, and industrial environments safely.",
    icon: <FaUserShield className="text-white text-3xl" />,
    bgColor: "bg-primary",
  },
  {
    id: 2,
    title: "Effective & Targeted Treatment",
    description:
      "We use proven pest control and fumigation methods that eliminate pests at the source and prevent recurrence.",
    icon: <FaBug className="text-white text-3xl" />,
    bgColor: "bg-secondary",
  },
  {
    id: 3,
    title: "Eco-Friendly & Safe Solutions",
    description:
      "Our treatments use approved, environmentally friendly chemicals that are safe for people, pets, and property.",
    icon: <FaLeaf className="text-white text-3xl" />,
    bgColor: "bg-primary",
  },
  {
    id: 4,
    title: "Compliance & Preventive Plans",
    description:
      "We follow health and safety standards and offer scheduled maintenance plans to ensure long-term pest control.",
    icon: <FaClipboardCheck className="text-white text-3xl" />,
    bgColor: "bg-secondary",
  },
];

const services = [
  {
    title: "Residential Pest Control",
    desc: "Effective pest control solutions for homes, apartments, and residential compounds.",
    icon: <FaHome />,
    bg: "bg-primary/10",
    textColor: "text-gray-800",
    buttonColor: "bg-primary text-secondary hover:bg-primary/80",
  },
  {
    title: "Commercial & Office Fumigation",
    desc: "Professional fumigation services for offices, hotels, hospitals, and commercial buildings.",
    icon: <FaBug />,
    bg: "bg-secondary/10",
    textColor: "text-gray-800",
    buttonColor: "bg-secondary text-primary hover:bg-secondary/80",
  },
  {
    title: "Industrial & Warehouse Pest Control",
    desc: "Specialized pest management solutions for warehouses, factories, and storage facilities.",
    icon: <FaWarehouse />,
    bg: "bg-primary/10",
    textColor: "text-gray-800",
    buttonColor: "bg-primary text-secondary hover:bg-primary/80",
  },
  {
    title: "Preventive & Maintenance Programs",
    desc: "Scheduled inspections and preventive pest control plans designed to stop infestations before they start.",
    icon: <FaShieldAlt />,
    bg: "bg-secondary/10",
    textColor: "text-gray-800",
    buttonColor: "bg-secondary text-primary hover:bg-secondary/80",
  },
];

// const materials = [
//     {
//         id: 2,
//         name: "Compactor",
//         image: compactor,
//     },
//     {
//         id: 3,
//         name: "Concrete Mixer",
//         image: mixer,
//     },
//     {
//         id: 4,
//         name: "Scaffolding",
//         image: Scaffolding,
//     },
// ];

const highlights = [
  {
    icon: <FaBug />,
    text: "Comprehensive pest control for insects, rodents, termites, and crawling pests",
  },
  {
    icon: <FaShieldAlt />,
    text: "Safe and approved chemicals that meet health and environmental standards",
  },
  {
    icon: <FaLeaf />,
    text: "Eco-friendly fumigation solutions suitable for homes and workplaces",
  },
  {
    icon: <FaClock />,
    text: "Fast response, scheduled treatments, and preventive maintenance plans",
  },
];


function EquippmentRent() {
    return (
        <div>
            <section
                className="relative w-full h-[30vh] md:h-[40vh] bg-cover bg-center mb-10"
                style={{ backgroundImage: `url(${herobg})` }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-75"></div>
                <div className="relative z-10 flex flex-col items-start justify-center h-full px-6 md:px-12 max-w-6xl mx-auto text-white">
                    <h1 className="text-4xl md:text-5xl  font-bold mb-4">
                        Pest & Fumigation Services
                    </h1>
                    <div className="flex items-center text-sm md:text-base space-x-2 text-gray-200">
                        <Link to="/" className="hover:text-white cursor-pointer">
                            Home
                        </Link>
                        <span>/</span>
                        <Link to="/about" className="text-gray-300 underline hover:text-white cursor-pointer">
                            Pest & Fumigation
                        </Link>
                    </div>
                </div>
            </section>

            <section className="py-20 bg-white">
                <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

                    {/* Left Image Section */}
                    <motion.div
                        initial={{ opacity: 0, x: -60 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                        viewport={{ once: true }}
                        className="relative"
                    >
                        <img
                            src={pest}
                            alt="pest"
                            loading="lazy"
                            className="w-full h-[420px] md:h-[500px] object-cover rounded-lg shadow-lg"
                        />

                        {/* Vertical Badge */}
                        <motion.div
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1.2 }}
                            viewport={{ once: true }}
                            className="absolute right-0 bottom-0 -translate-y-1/2 -translate-x-1/2 bg-primary text-secondary py-6 px-4 rounded-r-sm shadow-md flex items-center justify-center"
                            style={{ writingMode: "vertical-rl", textOrientation: "mixed" }}
                        >
                            <p className="text-xl font-semibold tracking-wide uppercase whitespace-nowrap">
                                Trusted Pest Control
                            </p>
                        </motion.div>
                    </motion.div>

                    {/* Right Content */}
                    <motion.div
                        initial={{ opacity: 0, x: 60 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                        viewport={{ once: true }}
                    >
                        <p className="uppercase tracking-widest text-sm font-semibold text-gray-500 mb-2">
                            Trusted Partner
                        </p>
                       
                      <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 leading-tight">
                         Professional <span className="text-primary"> Pest & Fumigation </span> Services
                      </h2>
                      <p className="text-gray-600 mb-8 text-lg">
        
        Our solutions are designed to eliminate pests while protecting people,
        property, and the environment.
      </p>

                        {/* Key Highlights */}
                        <div className="space-y-5">
                            {highlights.map((item, index) => (
                                <motion.div
                                    key={index}
                                    className="flex items-start gap-4"
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.6, delay: index * 0.2 }}
                                    viewport={{ once: true }}
                                >
                                    <div className="text-primary text-2xl">{item.icon}</div>
                                    <p className="text-gray-700 text-lg font-medium">{item.text}</p>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </section>

            <section className="py-16 bg-gray-50">
                <div className="max-w-6xl mx-auto px-4">
                    <h2 className="text-3xl font-bold text-center mb-12">
                        Why Clients Choose Our Pest & Fumigation Services
                    </h2>

                    <div className="grid gap-12 sm:gap-8 sm:grid-cols-2 lg:grid-cols-4">
                        {categories.map((category, index) => (
                            <motion.div
                                key={category.id}
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: index * 0.2 }}
                                className="relative bg-white shadow-lg rounded-xl p-6 pt-16 flex flex-col items-center text-center"
                            >
                                {/* Icon centered at the top border */}
                                <div
                                    className={`absolute -top-8 left-1/2 transform -translate-x-1/2 w-20 h-20 rounded-full flex items-center justify-center ${category.bgColor}`}
                                >
                                    {category.icon}
                                </div>

                                {/* Title */}
                                <h3 className="text-xl font-semibold mt-4">{category.title}</h3>

                                {/* Description */}
                                <p className="text-gray-600 mt-2">{category.description}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-20 bg-white">
                <div className='max-w-6xl mx-auto flex flex-col items-center'>
                    <h2 className="text-3xl font-bold text-center mb-12">
                         Comprehensive Pest & Fumigation Solutions.
                    </h2>

                    <div className=" px-6 flex flex-col md:flex-row gap-12 items-center">

                        {/* Left Side Image */}
                        <motion.div
                            className="w-full md:w-1/2"
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                        >
                            <img
                                src={fumigation}
                                alt="Pest and Fumigation"
                                loading="lazy"
                                className="w-full h-[90vh] object-cover rounded-lg shadow-lg"
                            />
                        </motion.div>

                        {/* Right Side Services */}
                        <div className="w-full md:w-1/2 flex flex-col gap-4">
                            {services.map((service, index) => (
                                <motion.div
                                    key={index}
                                    className={`${service.bg} ${service.border || ""} ${service.textColor} p-8 rounded-lg shadow-lg`}
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.6, delay: index * 0.2 }}
                                    viewport={{ once: true }}
                                >
                                    <div className="flex items-center gap-4 mb-2">
                                        <div className="text-4xl">{service.icon}</div>
                                        <h3 className="text-2xl font-semibold">{service.title}</h3>
                                    </div>
                                    <p className="mb-2 text-sm md:text-base">{service.desc}</p>
                                
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>

            </section>

            <section
                className="relative py-16 mb-16 bg-cover bg-center bg-fixed"
                style={{
                    backgroundImage: `url(${bgImage})`,
                }}
            >
                {/* Overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-60"></div>

                {/* Content */}
                <div className="relative z-10 max-w-5xl mx-auto text-center px-4">
                    <motion.h2
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="text-3xl md:text-4xl font-bold text-white mb-6"
                    >
                        Need Professional Pest & Fumigation Services?
                    </motion.h2>

                    <motion.p
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        className="text-gray-200 text-base md:text-lg mb-8 max-w-3xl mx-auto"
                    >
                        Protect your home, office, or industrial facility from pests with our safe,
                        effective, and eco-friendly pest control and fumigation solutions.
                    </motion.p>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                    >
                        <Link
                            to="/quote"
                            className="inline-block bg-primary  text-secondary font-semibold px-10 py-4 rounded-lg shadow-lg transition-all duration-300"
                        >
                            Get a Quote
                        </Link>
                    </motion.div>
                </div>
            </section>

        </div>
    )
}

export default EquippmentRent